import { Tooltip } from "@mui/material";

interface IVendorTypeCellRendererProps {
  data: {
    vendor?: string;
    device_type?: string;
  };
}

const VendorTypeCellRenderer: React.FC<IVendorTypeCellRendererProps> = ({
  data,
}) => {
  if (!data?.vendor || !data?.device_type) {
    return <span>-</span>;
  }

  const vendor = data.vendor;
  const type = data.device_type;
  const displayText = `${vendor.charAt(0).toUpperCase()}${vendor.slice(1)} - ${type.charAt(0).toUpperCase()}${type.slice(1)}`;

  return (
    <Tooltip
      title={
        <span style={{ fontWeight: 500 }}>
          {displayText}
        </span>
      }
      arrow
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "#fff",
            color: "#000",
            boxShadow: 1,
            fontSize: "0.775rem",
          },
        },
        arrow: { sx: { color: "#fff" } },
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
        }}
      >
        {displayText.length > 20 ? `${displayText.substring(0, 20)}…` : displayText}
      </span>
    </Tooltip>
  );
};

export default VendorTypeCellRenderer;
